unit UAttachmentList;

interface

uses
  System.Contnrs, UAttachmentModel, Js, UEssentialHelper;

const
  ATTACHMENTLISTKEY = 'AttachmentList_';

type
  TAttachmentList = class(TObjectList)
  private
    FFakNr: string;
    FPersonalNr: string;
    FOnListChanged: TListChangedEvent;
    FKind: TAttachmentKind;
    function GetItem(i: Integer): TAttachmentModel;
    procedure DoListChanged;
    procedure HandlePropertyChanged(Sender: TObject; PropertyName: string);
    procedure Sort;
    procedure SetValues(Json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetOnListChanged(const Value: TListChangedEvent);
  public
    constructor Create;
    function AreItemsSelected: Boolean;
    function Exists(Item: TAttachmentModel): Boolean;
    function GetByKindAndFilename(Kind: TAttachmentKind; Filename: string)
      : TAttachmentModel;
    function IndexOf(Item: TAttachmentModel): Integer;
    function NotTransmitted: TAttachmentList;
    function ToJson: string;
    procedure Add(Item: TAttachmentModel);
    procedure Delete(i: Integer);
    procedure Load;
    procedure Store;
    property Items[i: Integer]: TAttachmentModel read GetItem;
    property OnListChanged: TListChangedEvent read FOnListChanged
      write SetOnListChanged;
    property FakNr: string read FFakNr write FFakNr;
    property PersonalNr: string read FPersonalNr write FPersonalNr;
    property Kind: TAttachmentKind read FKind write FKind;
  end;

implementation

uses
  WebLib.Json, System.SysUtils, WebLib.Storage, WebLib.REST, WebLib.Controls;

{ TAttachmentList }

procedure TAttachmentList.Add(Item: TAttachmentModel);
begin
  if not Self.Exists(Item) then
  begin
    Item.OnPropertyChanged := Self.HandlePropertyChanged;
    inherited Add(Item);
    Self.Sort;
  end;
end;

{ constructor TAttachmentList.Create(FakNr: string; PersonalNr: string;
  LocalLoad: Boolean; Kind: TAttachmentKind);
  var
  s: string;
  begin
  inherited Create;
  FKind := Kind;
  FFakNr := FakNr;
  FPersonalNr := PersonalNr;
  if LocalLoad then
  begin
  s := TLocalStorage.GetValue(ATTACHMENTLISTKEY + Self.FakNr + '_' +
  Self.PersonalNr);
  if s <> '' then
  Self.SetValues(s);
  end;
  end; }

function TAttachmentList.AreItemsSelected: Boolean;
var
  i: Integer;
begin
  Result := false;
  i := 0;
  while not Result and (i < Self.Count) do
    if Self.Items[i].Selected then
      Result := true
    else
      Inc(i);
end;

constructor TAttachmentList.Create;
begin
  inherited;
  Self.Kind := akUnknown;
  Self.FakNr := '';
  Self.PersonalNr := '';
end;

procedure TAttachmentList.Delete(i: Integer);
begin
  if (i >= 0) and (i < Self.Count) then
  begin
    inherited Delete(i);
    Self.DoListChanged;
  end;
end;

procedure TAttachmentList.DoListChanged;
begin
  if Assigned(Self.OnListChanged) then
  begin
    Self.Store;
    Self.OnListChanged(Self);
  end;
end;

function TAttachmentList.Exists(Item: TAttachmentModel): Boolean;
begin
  Result := Self.IndexOf(Item) >= 0;
end;

function TAttachmentList.GetByKindAndFilename(Kind: TAttachmentKind;
  Filename: string): TAttachmentModel;
var
  i: Integer;
  found: Boolean;
  Item: TAttachmentModel;
begin
  i := 0;
  found := false;
  while not found and (i < Self.Count) do
  begin
    Item := Self.Items[i];
    if (Item.Kind = Kind) and (Item.Filename = Filename) then
      found := true
    else
      Inc(i);
  end;
  if found then
    Result := Self.Items[i]
  else
    Result := nil;
end;

function TAttachmentList.GetItem(i: Integer): TAttachmentModel;
begin
  Result := inherited GetItem(i) as TAttachmentModel;
end;

procedure TAttachmentList.HandlePropertyChanged(Sender: TObject;
  PropertyName: string);
begin
  if (PropertyName = 'TransmittedAt') or (PropertyName = 'Selected') then
    Self.DoListChanged;
end;

function TAttachmentList.IndexOf(Item: TAttachmentModel): Integer;
var
  i: Integer;
  found: Boolean;
begin
  i := 0;
  found := false;
  while not found and (i < Self.Count) do
    if (Self.Items[i].Filename = Item.Filename) and
      (Self.Items[i].Kind = Item.Kind) then
      found := true
    else
      Inc(i);
  if found then
    Result := i
  else
    Result := -1;
end;

procedure TAttachmentList.Load;
var
  s: string;
begin
  if (Self.FakNr <> '') and (Self.PersonalNr <> '') then
  begin
    s := TLocalStorage.GetValue(ATTACHMENTLISTKEY + Self.FakNr + '_' +
      Self.PersonalNr);
    if s <> '' then
      Self.SetValues(s);
  end;
end;

function TAttachmentList.NotTransmitted: TAttachmentList;
var
  i: Integer;
begin
  Result := TAttachmentList.Create;
  Result.FakNr := Self.FakNr;
  Result.PersonalNr := Self.PersonalNr;
  Result.Kind := akUnknown;
  for i := 0 to Self.Count - 1 do
    if Self.Items[i].TransmittedAt = 0 then
      Result.Add(Self.Items[i]);
end;

procedure TAttachmentList.SetValues(obj: TJsObject);
var
  i, Count: Integer;
  dummy: TListChangedEvent;
  Item: TAttachmentModel;
begin
  Self.Clear;
  dummy := Self.OnListChanged;
  Self.OnListChanged := nil;
  if obj['Count'] <> nil then
  begin
    Count := StrToInt(string(obj['Count']));
    for i := 0 to Count - 1 do
      if obj['Item' + IntToStr(i)] <> nil then
      begin
        Item := TAttachmentModel.Create(string(obj['Item' + IntToStr(i)]));
        if Self.Kind = akUnknown then
          Self.Add(Item)
        else if Item.Kind = Self.Kind then
          Self.Add(Item);
      end;
  end;
  Self.OnListChanged := dummy;
  Self.DoListChanged;
end;

procedure TAttachmentList.SetOnListChanged(const Value: TListChangedEvent);
begin
  FOnListChanged := Value;
end;

procedure TAttachmentList.SetValues(Json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(Json);
  Self.SetValues(obj);
end;

procedure TAttachmentList.Sort;
var
  i: Integer;
  j: Integer;
begin
  if Self.Count > 1 then
  begin
    for i := 0 to Self.Count - 1 do
      for j := 0 to Self.Count - 2 do
        if Self.Items[j].CreatedAt < Self.Items[j + 1].CreatedAt then
          Self.Exchange(j, j + 1);
  end;
  Self.DoListChanged;
end;

procedure TAttachmentList.Store;
begin
  if (Self.FakNr <> '') and (Self.Kind = akUnknown) then
    TLocalStorage.SetValue(ATTACHMENTLISTKEY + Self.FakNr + '_' +
      Self.PersonalNr, Self.ToJson);
end;

function TAttachmentList.ToJson: string;
var
  obj: TJsonObject;
  i: Integer;
begin
  obj := TJsonObject.Create;
  obj.AddPair('Count', IntToStr(Self.Count));
  for i := 0 to Self.Count - 1 do
    obj.AddPair('Item' + IntToStr(i), Self.Items[i].ToJson);
  Result := obj.ToJson;
  obj.Free;
end;

end.
